import { forwardRef, MouseEvent } from "react"
import { Group, GroupProps } from "@mantine/core"
import clsx from "clsx"
import { IItemSelectionState } from "../../utils/useSelection"
export interface DefaultListItemSelectable<T> extends GroupProps {
  selectionState?: IItemSelectionState<T>
  entity: T
  selectionOverride?: boolean
}

export interface DefaultListItemNonSelectable extends GroupProps {
  selectionState?: undefined
  entity?: undefined
  selectionOverride?: undefined
}

export type DefaultListItemProps<T> =
  | DefaultListItemSelectable<T>
  | DefaultListItemNonSelectable

export const DefaultListItem = forwardRef<
  HTMLDivElement,
  // we want to allow any type of data,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  DefaultListItemProps<any>
>(({ selectionState, selectionOverride, entity, ...props }, ref) => {
  const { isSelected, toggle } = selectionState
    ? selectionState
    : { isSelected: undefined, toggle: undefined }

  return (
    <Group
      ref={ref}
      p="xs"
      className={clsx(
        (props.onClick || selectionState) && "custom-list-item",
        (selectionOverride !== undefined ? selectionOverride : isSelected) &&
          "selected-custom-list-item"
      )}
      wrap="nowrap"
      style={props.onClick ? { cursor: "pointer" } : undefined}
      justify="space-between"
      {...props}
      onClick={(evt: MouseEvent<HTMLDivElement>) => {
        if (props.onClick) {
          props.onClick(evt)
        }
        toggle && toggle(entity)
      }}
    />
  )
})

DefaultListItem.displayName = "DefaultListItem"
